import { SpaceProvider } from "@/components/spaces/context/index.ts";
import { FloatingSpaceLoading } from "@/components/spaces/space-detail/loading-skeletons.tsx";
import { SpaceLayout } from "@/components/spaces/space-detail/space-layout.tsx";
import { spaceQueryOptions } from "@/services/spaces-service.ts";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute(
	"/_authenticated/dashboard/projects/$projectId/files",
)({
	component: ProjectFilesView,
});

// Projects are spaces (provider="project"), so the project files tab reuses the
// same file explorer as spaces — tree, grid/list, folders, search, drag-drop.
// The project detail page is a tall vertical stack, so the explorer lives in a
// bounded box and relies on its own internal scroll.
function ProjectFilesView() {
	return (
		<div className="flex h-[70vh] min-h-[480px] flex-col">
			<Suspense
				fallback={<FloatingSpaceLoading className="rounded-lg border" />}
			>
				<ProjectFileExplorer />
			</Suspense>
		</div>
	);
}

function ProjectFileExplorer() {
	const { projectId } = Route.useParams();
	const { data: space } = useSuspenseQuery(spaceQueryOptions(projectId));

	return (
		<SpaceProvider space={{ id: projectId, ...space }}>
			<SpaceLayout />
		</SpaceProvider>
	);
}
